













import { Component, Prop, Vue } from 'vue-property-decorator'

import tinymce from 'tinymce'

import 'tinymce/themes/silver/theme.min.js'
// import 'tinymce/icons/default/icons'
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/codesample'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/media'
import 'tinymce/plugins/emoticons'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/hr'
import 'tinymce/plugins/paste'

import Editor from '@tinymce/tinymce-vue'
import { Upload } from 'ant-design-vue'
import { uploadToPublicFolder } from '@/api/utils'

@Component({ name: 'TinymceEditor', components: { Editor } })

export default class TinymceEditor extends Vue {
  @Prop({ default: '' }) content!: string;

  // 富文本框值
  private value: string = '';
  private tinymceFlag: any = 2;
  // const _that:any = this
  private publicPath = process.env.VUE_APP_API_BASE_URL

   
  // 富文本框init配置
  private get init() {
    if(this.publicPath==='https://www.yibiao163.cn'){
      this.publicPath = 'https://jnjc.yibiao163.cn'
    }
    if(this.publicPath==='http://192.168.99.207:7600'){
      this.publicPath = 'http://192.168.99.207'
    }
    const that = this
    return {
      selector: '#tinymce',
      language_url: process.env.NODE_ENV==='development'?'/langs/zh_CN.js':this.publicPath+'/energygov/langs/zh_CN.js',
      language: 'zh_CN',
      skin_url: process.env.NODE_ENV==='development'?'/skins/ui/oxide': this.publicPath+'/energygov/skins/ui/oxide',
      height: 350,
      branding: false,
      table_toolbar:'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
      plugins:
        'link lists image  code table wordcount  table fullscreen preview pagebreak insertdatetime hr paste', // 插件
      toolbar:
        'image bold italic underline alignleft aligncenter alignright alignjustify | forecolor backcolor | fontselect | fontsizeselect | formatselect |  bullist numlist | outdent indent blockquote | removeformat| undo redo | link unlink media insertdatetime table  hr pagebreak | fullscreen preview | strikethrough', // 工具条
      font_formats:
        'sans-serif; 宋体=SimSun;', // 字体
      fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px 64px 72px', // 文字大小
      paste_data_images: true,
      formats:{

     
       fontsize: { block: 'p',styles : {fontSize:'%value'} },
       forecolor:{ block: 'p',styles : {color:'%value'} },
       underline: { block: 'p', styles: { 'text-decoration': 'underline' }, exact: true },
      fontname:{ block: 'p', styles: { 'font-family': '%value' }, exact: true },
      hilitecolor:{ block: 'p', styles: { 'background-color': '%value' }, exact: true }
      },
      codesample_languages: [
        { text: 'HTML/XML', value: 'markup' },
        { text: 'JavaScript', value: 'javascript' },
        { text: 'CSS', value: 'css' },
        { text: 'Java', value: 'java' },
        { text: 'C++', value: 'cpp' },
      ],
      // 图片上传回调
      images_upload_handler: (blobInfo: any, success: any,failure:any) => {
        const file = blobInfo.blob()
        const suffix = file.type.slice(6)
       
        var reader = new FileReader()
        reader.readAsDataURL(blobInfo.blob())
        reader.onload = function (e: any) {
          const base64 = e.target.result
          uploadToPublicFolder({bytes:base64,suffix}).then((res:any)=>{
            if(res&&res.status===0){
               success(
            res.data
        )
            }  else {
              // failure(res.message)
              that.$message.error(res.message)
            }
          })
          // success(this.result)
        }
        // this.$api.common.aliyunUpload(file, 'donggu').then((url: any) => {
       
        // })
      },
    }
  }

  mounted() {
    this.tinymceFlag++
    tinymce.init({})
    this.value = this.content
  
  }
  beforeDestroy() {
    // 销毁组件前销毁编辑器
    //   tinymce.destroy()
  }

  activated() {
    // 每次都给编辑器改变不同的key值使其每次切换页面都重新加载
    alert(this.tinymceFlag)
    this.tinymceFlag++
  }
  onEditorInput(e: any) {
    this.$emit('input', this.value)
  }
  // 禁用富文本编辑器
  setMode(){
   tinymce.activeEditor.setMode('readonly')
  }
  setContent(str: any) {
    this.value = str
  }
}
